import { postMemberGhlForm } from '../../../../../../global/ducks/mlps-api';
import { YesNoIndicators } from '../../../../../../global/models/api-model';
import { PensionEnrollmentPlan, PensionEnrollmentPlanType } from '../../../pension-enrollment/models/pension-enrollment-model';
import { CoveragePerson, declineCoverageReasonOther, DeclinedValue, PlanTypes } from '../../enrollment/models/coverage-models';
import { CalculatedTiers } from '../../models/new-hire-enrollment-models';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';
import { MemberCompletedCoverage, MemberCoverageFormModel, MemberPendingCoverage } from '../models/member-coverage-model';

export function getPlanPayload(value: string, selectedTier?: string) {

	if (!value) {
		return null;
	}

	if (value === DeclinedValue) {
		return { declined: YesNoIndicators.Yes };
	}
	const payload: any = { plan_code: value };

	if (selectedTier) {
		payload.tier = selectedTier;
	}

	return payload;
}

export function onSubmit(
	dispatch: any,
	step: BenefitEnrollmentStep,
	onSuccess: any,
	values: MemberCoverageFormModel,
	memberGuid: string,
	employerId: string,
	formId: number,
	eligibleDependents: CoveragePerson[],
	medicalTier: CalculatedTiers,
	dentalTier: CalculatedTiers,
	navigateToReview: () => void,
	pendingPlans: MemberPendingCoverage,
) {
	if (step === BenefitEnrollmentStep.COVERAGE) {
		navigateToReview();
		return;
	}

	const payload: any = {
		ghl_enrollment_params: {
			global_edited: {
				memo: values?.memo,
				special_requests: values?.specialRequests,
			},
		},
	};


	const dependents = eligibleDependents?.map(
		d => {
			const enrollmentDependent: any = {};
			enrollmentDependent.guid = d?.guid;
			enrollmentDependent.medical = values?.medicalDependents?.includes(d?.guid) ? YesNoIndicators.Yes : YesNoIndicators.No;
			enrollmentDependent.dental = values?.dentalDependents?.includes(d?.guid) ? YesNoIndicators.Yes : YesNoIndicators.No;
			return enrollmentDependent;
		});

	if (pendingPlans.medical?.plans?.length > 0) {
		payload.ghl_enrollment_params[PlanTypes.M] = getPlanPayload(values.M, medicalTier?.selected_tier);

		if (values.medicalDeclineReason) {
			payload.ghl_enrollment_params[PlanTypes.M] = {
				...payload.ghl_enrollment_params[PlanTypes.M],
				decline_reason:
					values.medicalDeclineReason === declineCoverageReasonOther ?
						values?.medicalDeclineReasonOther :
						values.medicalDeclineReason,
			};
		}

	}
	if (pendingPlans.dental?.plans?.length > 0)
		payload.ghl_enrollment_params[PlanTypes.D] = getPlanPayload(values.D, dentalTier?.selected_tier);

	if (pendingPlans.long_term_disability?.plans?.length > 0)
		payload.ghl_enrollment_params[PlanTypes.L] = getPlanPayload(values.L);
	if (pendingPlans.short_term_disability?.plans?.length > 0)
		payload.ghl_enrollment_params[PlanTypes.W] = getPlanPayload(values.W);




	payload.ghl_enrollment_params.dependent_enrollments_edited = dependents || [];
	dispatch(postMemberGhlForm(memberGuid, employerId, formId, payload, (res) => onSuccess(res, values)));


}



export function ShouldShowMemberCafeteriaAcknowledgement(completedPlans: MemberCompletedCoverage, formValue: MemberCoverageFormModel, numberOfDays: number) {

	const hasCompleted = completedPlans?.medical?.plan?.name || completedPlans?.dental?.plan?.name || completedPlans?.long_term_disability?.plan?.name || completedPlans?.short_term_disability?.plan?.name;
	const enrolledInPending = formValue?.M || formValue?.D || formValue?.L || formValue?.W;

	return ((hasCompleted || enrolledInPending) && (numberOfDays > 30));

}

export function GetEnrolledPlansConfirmationPageModel(completedPlans: MemberCompletedCoverage, formValue: MemberCoverageFormModel, enrolledPensions: PensionEnrollmentPlan[]) {

	return {
		health: !!(completedPlans?.medical?.plan?.name || completedPlans?.dental?.plan?.name || formValue?.M || formValue?.D),
		layDc: !!enrolledPensions?.find(p => p.plan_type === PensionEnrollmentPlanType.DcPlan),
		layDb: !!enrolledPensions?.find(p => p.pbpor_id.includes('LayDB')),
		clergyDb: !!enrolledPensions?.find(p => p.pbpor_id.includes('ClergyDB')),
		rsvp: !!enrolledPensions?.find(p => p.plan_type === PensionEnrollmentPlanType.RsvpPlan),
		groupLife: !!completedPlans?.group_life?.plan?.name,
		disability: !!(completedPlans?.long_term_disability?.plan?.name || completedPlans?.short_term_disability?.plan?.name || formValue?.L || formValue?.W),
	};
}